<template>
  <el-table
    :data="item.contents"
    style="width: 100%"
    size="small"
    striped
    border
  >
    <el-table-column
      prop="origin"
      label="Origin"
    />
    <el-table-column
      prop="description"
      label="Description"
    />
    <el-table-column
      prop="quantity"
      label="Quantity"
    />
    <el-table-column
      prop="value"
      label="Value"
      :formatter="(row, col, cellValue) => '$' + cellValue"
    />
    <el-table-column
      prop="weight"
      label="Weight"
      :formatter="(row, col, cellValue) => cellValue + 'kg'"
    />
    <el-table-column
      prop="tariff_code"
      label="Tariff Code"
    />
  </el-table>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>
